var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-list",
    _vm._l(_vm.appTypes, function (app) {
      return _c(
        "v-list-item",
        { key: app.name },
        [
          _c("SoliBtn", {
            attrs: {
              block: "",
              text: app.name,
              color: "soli-grey",
              outlined: "",
              disabled: app.disabled,
            },
            on: {
              click: function ($event) {
                return _vm.$emit("input", app)
              },
            },
          }),
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }